import { TrendingUp, TrendingDown, Minus } from 'lucide-react'

export const formatCurrency = (value: number | undefined | null) => {
  if (value === undefined || value === null) return 'R$ 0,00'
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  }).format(Math.abs(value))
}

export const formatDate = (dateString: string) => {
  const date = new Date(dateString)
  return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export const getResultColor = (value: number | undefined | null) => {
  if (value === undefined || value === null) return 'text-brand-gray'
  return value > 0 ? 'text-green-400' : 'text-red-400'
}

export const getHealthColor = (indicator: string, value: number) => {
  switch (indicator) {
    case 'endividamento':
      if (value < 0.5) return 'text-green-400'
      if (value < 0.8) return 'text-yellow-400'
      return 'text-red-400'
    case 'pmr':
      if (value <= 30) return 'text-green-400'
      if (value <= 45) return 'text-yellow-400'
      return 'text-red-400'
    default:
      return 'text-white'
  }
}

export const getPerformanceColor = (performance: number) => {
  if (performance >= 50) return 'stroke-green-500'
  if (performance >= 30) return 'stroke-yellow-500'
  return 'stroke-red-500'
}

export const getPerformanceTextColor = (performance: number) => {
  if (performance >= 50) return 'text-green-500'
  if (performance >= 30) return 'text-yellow-500'
  return 'text-red-500'
}

export const formatPercentage = (value: number | undefined | null) => {
  if (value === undefined || value === null) return '0.0%'
  return `${value > 0 ? '+' : ''}${value.toFixed(1)}%`
}

export const getVarianceColor = (variance: number) => {
  if (variance > 5) return 'text-brand-primary'
  if (variance < -5) return 'text-red-400'
  return 'text-brand-gray'
}

export const getVarianceIconData = (variance: number) => {
  if (variance > 5) return { Icon: TrendingUp, className: 'text-brand-primary' }
  if (variance < -5) return { Icon: TrendingDown, className: 'text-red-400' }
  return { Icon: Minus, className: 'text-brand-gray' }
}